import { type Options, titleCase } from 'title-case';
import { lowerCaseValue } from './lowerCaseValue';
import { normalizeValue } from './normalizeValue';
import { upperCaseValue } from './upperCaseValue';

const options: Options = {
	locale: 'en-US',
};

const specialPrefixes = ['Mc', "O'"];

function titleCaseWord(value: string): string {
	let formatted = normalizeValue(value);

	// If the value is all uppercase, convert it to lowercase before changing to title case
	if (formatted === upperCaseValue(formatted)) {
		formatted = lowerCaseValue(formatted);
	}

	// If value is blank, just return an empty string
	if (!formatted) {
		return '';
	}

	formatted = titleCase(formatted, options);

	// If the value is a special prefix, title case the part that follows the prefix
	for (const prefix of specialPrefixes) {
		const prefixLength = prefix.length;
		if (formatted.startsWith(prefix) && formatted.length > prefixLength) {
			const prefixValue = formatted.slice(0, prefixLength);
			const suffixValue = formatted.slice(prefixLength);
			formatted = `${prefixValue}${titleCaseWord(suffixValue)}`;
			break;
		}
	}

	return formatted;
}

export function titleCaseValue(value: string | undefined): string | undefined {
	const formatted = normalizeValue(value);
	if (!formatted) {
		return undefined;
	}

	let parts = formatted.split(' ');
	parts = parts.map(titleCaseWord);

	return parts.join(' ');
}
